export const clientManagement = {
    title: 'Client management',
    signUp: 'Sign up',
    clientId: 'Client ID',
    companyName: 'Company',
    industries: 'Organization name',
    contractDate: 'Created date',
    terminated: 'Status',
    isTerminated: 'Canceled',
    isActive: 'Active',
    trial: 'Trial',
    isStop: 'Emergency stop',
    isCreating: 'Creating',
    isErrored: 'Error',
    userManagementName: 'User management',
    aiManagement: 'AI analysis result management',
    clientInfoManagementName: 'Client information management',
    inquiry: 'Inquiry',
    clientName: 'Client Name',
    analysispermission: 'Consulting Analysis Mode Permission',
    analysispermissionNone: 'None',
    analysispermissionFull: 'Full Access',
    analysispermissionAvailable: 'Available',
    userFName: 'FName',
    userLName: 'LName',
    mailAddress: 'mailaddress',
    deleteFlag: 'status',
    createdDate: 'Registration date',
    date: 'Date',
    update: 'Update',
    cancel: 'Cancel',
    delete: 'Delete',
    add: 'Add',
    emergencySuspend: 'Emergency public suspension',
    emergencyRestart: 'Service restart',
    companyAddress: 'Address',
    phoneNumber: 'Phone number',
    trialStatus: 'on',
    termination: 'Cancellation',
    stopTermination: 'Cancellation Release',
    EmailInformationToAnalyzed: 'Published Client information',
    PublicTitle: 'Public confirmation',
    mailReceiptDate: 'Receipt Date',
    aIanalysisResultInformation: 'Information in processing data',
    aiResultLoadingDate: 'AI analysis result loading date',
    release: 'Release',
    back: 'Back',
    subscriptionModel: 'Subscription',
    promotionModel: 'Promotion',
    statue: 'Status',
    installDate: 'Installation date',
    publicDate: 'Release date',
    deleteDate: 'Delete date',
    mailRequestId: 'Request ID',
    AITopFrom: 'From mail Mode',
    AITopTo: 'To mail Mode',
    mailDomain1: 'MailDomain 1',
    mailDomain2: 'MailDomain 2',
    mailDomain3: 'MailDomain 3',
    // user Management
    userManagement: {
        active: 'Active',
        terminate: 'Deleted',
        reactive: 'Resurrection',
        userModalTitle: 'User details',
        userInfo: {
            userFName: 'FName',
            userLName: 'LName',
            mailAddress: 'Mailaddress',
            organization: 'Organization name',
            title: 'Title',
            phoneNumber: 'International Phone Number',
            phoneNumberTip: '(Example input: In the case of 09012345678, enter +819012345678)',
            analysispermission: {
                label: 'Consulting Analysis Mode Permission',
                none: 'None',
                full: 'Full Access',
                available: 'Available'
            }
        },
        warningMsg: {
            duplicatedUser: "The user has already existed. Can't register.",
            deleteInfo: 'Delete the user now. Is there any problem?',
            activeInfo: 'Enable the user now. Is there any problem?',
            userIdMissing: "User ID is missing. It's possible that authentication hasn't occurred yet."
        }
    },
    // clientInfo Management
    clientInfoManagement: {
        selectCompany: 'Company name',
        confirmStopTitle: 'Confirmation before the cancellation',
        confirmAcivityTitle: 'Cancellation of cancellation process',
        warningMsg: {
            companyNotMatch: 'The company name is incorrect.',
            terminationInfo: 'Cancel the corresponding client now. Is there any problem?',
            canceltTerminationInfo: 'Cancel the cancellation of the corresponding client now. Is there any problem?',
            terminationTips:
                '※Please note the client-related user will not be able to log in after canceling the contract.'
        }
    },
    suspendAndTermination: {
        emergencySuspendFalse: 'Emergency public suspension',
        emergencySuspendTrue: 'Service restart',
        modalInfoFalse: 'Would you like to stop the disclosure of information to clients in an emergency?',
        modalInfoTrue: 'Would you like to resume disclosing information to clients?',
        modalConfirmFalse: 'Stop',
        modalConfirmTrue: 'Restart',
        modalCancel: 'Cancel',
        invalidCompanyWarning: 'The company name is incorrect.'
    }
}
